import { apiClient } from './client'
import type { NomenclatureItem, CreateNomenclatureDto, UpdateNomenclatureDto, DynamicField } from '@/types'

/** Accept raw array or { success, data } envelope after axios interceptor edge cases. */
export function normalizeNomenclatureList(payload: unknown): NomenclatureItem[] {
  if (Array.isArray(payload)) return payload as NomenclatureItem[]
  if (payload && typeof payload === 'object' && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: NomenclatureItem[] }).data
  }
  return []
}

export const nomenclatureApi = {
  getAll: () =>
    apiClient.get<NomenclatureItem[] | { data: NomenclatureItem[] }>('/api/nomenclature'),

  getById: (gtin: string) =>
    apiClient.get<NomenclatureItem>(`/api/nomenclature/${gtin}`),

  create: (data: CreateNomenclatureDto) =>
    apiClient.post('/api/nomenclature', data),

  update: (gtin: string, data: UpdateNomenclatureDto) =>
    apiClient.put(`/api/nomenclature/${gtin}`, data),

  delete: (gtin: string) =>
    apiClient.delete(`/api/nomenclature/${gtin}`),

  /** Get all unique dynamic field names across all nomenclature items */
  getDynamicFields: () =>
    apiClient.get<DynamicField[]>('/api/nomenclature/dynamic-fields'),

  /** Get all fields (standard + dynamic) for a specific item */
  getItemFields: (gtin: string) =>
    apiClient.get<Array<{ key: string; value: string; dynamic: boolean }>>(`/api/nomenclature/${gtin}/fields`),
}
